import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ITenant, ITenantFeature } from "@/types/tenant";

export const isOurTenant = (tenant: ITenant | null) =>
    tenant?.subdomain === "app";

export const getTenantState = (state: RootState) => state.tenant;

export const getTenant = createSelector(
    getTenantState,
    tenant => tenant.tenant,
);

export const getTenantId = createSelector(getTenant, tenant => tenant?.id);

export const getIs1TemplateTenant = createSelector(getTenant, tenant =>
    isOurTenant(tenant),
);

export const getTenantName = createSelector(getTenant, tenant => tenant?.name);

export const getTenantFeatures = createSelector(
    getTenant,
    tenant => tenant?.features,
);

export const getIsTenantFeatureEnabled = createSelector(
    [getTenantFeatures, (_: RootState, feature: ITenantFeature) => feature],
    (features, feature) => features?.[feature],
);

export const getIsCreditsEnabled = createSelector(
    getTenantFeatures,
    features => features?.[ITenantFeature.CREDITS],
);

export const getIsJobsEnabled = createSelector(
    getTenantFeatures,
    features => features?.[ITenantFeature.JOBS] ?? false,
);

export const getIsUserJobsEnabled = createSelector(
    getTenantFeatures,
    features => features?.[ITenantFeature.USER_JOBS] ?? false,
);

export const getIsAtsScanEnabled = createSelector(
    getTenantFeatures,
    features => features?.[ITenantFeature.ATS_SCAN] ?? false,
);

export const getTenantExternalLinks = createSelector(
    getTenant,
    tenant => tenant?.externalLinks,
);

export const getTenantImages = createSelector(
    getTenant,
    tenant => tenant?.images,
);

export const getIsAiEnabled = createSelector(
    getTenantFeatures,
    features => features?.[ITenantFeature.AI] ?? false,
);
